import Vue from 'vue'
import { MessageBox, Button, Input, Loading, Dialog, Upload, Divider,Radio,RadioGroup,Message,Popover,Rate,Image,RadioButton,
  Form, FormItem, Select, Option, Row, Col, Tabs, TabPane, Card} from 'element-ui'
// import ElementUI from 'element-ui'
import Avatar from './components/avatar.vue'
import Index from './index.vue'
import store from './store/index'
import router from './router'
import tim from 'tim'
import TIM from 'tim-js-sdk'
import TYPES from './utils/types'
// import 'lib-flexible'
import '@/assets/icon/iconfont.css'
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();
// Vue.use(vConsole)

window.tim = tim
window.TIM = TIM
// window.store = store
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
Vue.prototype.TYPES = TYPES
// Vue.use(ElementUI)
Vue.prototype.$store = store
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
Vue.use(Button)
Vue.use(Card)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Divider)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Rate)
Vue.use(Image)
Vue.use(Popover)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Rate)
Vue.use(RadioButton)
Vue.component('avatar', Avatar)
Vue.config.devtools = true;

new Vue({
  router,
  render: h => h(Index)
}).$mount('#app')
